/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useHistory, RouteComponentProps } from 'react-router-dom'
import ptBR from 'date-fns/locale/pt-BR';
import { formatDate, formatGroupBy, onlyNumberStr, formatDateHorsComDiaSemana } from '../../utils/format';
import {
  Button,
  Container,
  DivItems,
  FiltersContainer,
  LogoFooter,
  Main,
  RightButtons,
  Row,
} from './styles';
import LogoDevari from '../../assets/images/logo.png'
import ReactToPrint from 'react-to-print'
import { FaPlusSquare, FaMinusSquare } from 'react-icons/fa';
import { DivRow } from './styles';
import { getClassesReport } from '../../services/providers';
import { useFormModal } from '../../contexts/formModal';
import Toast from '../../components/Toast';
import { getLicenseInfo } from '../../services/license';
import { convertToDate } from '../../utils/date';
import ResumeFiltersReport from '../../components/ResumeFiltersReport';
import format from 'date-fns/format';
import { VERSION } from '../../environment/stores';
interface IReport {
  Cidade?: ICidade;
  Classe?: IClasse;
  UF?: IUf;
  atualizadoEm?: string;
  bairro?: string;
  cep?: string;
  codigo?: string;
  criadoEm?: string;
  endereco?: string;
  id?: string;
  inscricaoEstadual?: string;
  nome?: string;
  nomeFantasia?: string;
  numeroEndereco?: string;
  telefone?: string;
  celular?: string;
}

interface ICidade {
  id?: string;
  nome?: string;
}

interface IClasse {
  id?: string;
  nome?: string;
}

interface IUf {
  id?: string;
  nome?: string;
  codigo?: string;
}

interface IField {
  label: string;
  field: string;
  orderName?: string;
}

interface Props extends RouteComponentProps {
  title: string;
  endpoint: string;
  filters: any;
  extraction?: any;
}

const ORDER_FIELD_PROVIDERS: IField[] = [
  { label: 'Nome', field: 'nome' },
]

const ClassesReport: React.FC<Props> = ({ title, endpoint, filters }) => {

  const location = useLocation<any>();
  const history = useHistory<any>();
  const { openModal } = useFormModal();
  const componentRef = useRef(null);
  const [reports, setReports] = useState<Array<IReport> | any>(null);
  const [marcaTexto, setMarcaTexto] = useState(false);
  const [gerarCabecalho, setGerarCabecalho] = useState(false);
  const [openList, setOpenList] = useState<Array<string>>([]);
  const [license, setLicense] = useState<any>(null);
  const [filterLabel, setFilterLabel] = useState<any>([])
  const [nivelArvore, setNivelArvore] = useState<number | null>(null);
  const fields = ORDER_FIELD_PROVIDERS;
  const hasGroup = false;
  const date = new Date();

  useEffect(() => {
    getLicense();
  }, []);

  useEffect(() => {
    if (location.state) {
      const details = location.state.filtersToGet
      const _filterLabels = location.state.filtersLabels
      if (_filterLabels) {
        setFilterLabel(_filterLabels)
      }

      if (details.marcaTexto) {
        setMarcaTexto(true)
        delete details.marcaTexto
      }
      
      if (details.gerarCabecalho) {
        setGerarCabecalho(true)
        delete details.gerarCabecalho
      }

      getReports(details, true);
      if (details.nivelArvore) setNivelArvore(details.nivelArvore);
      // set
    }
  }, []);

  async function getLicense() {
    try {
      const result = await getLicenseInfo();
      setLicense(result);
    } catch (error: any) {
      Toast.show(error, 'error');
    }
  }

  async function getReports(details: any, grouped:boolean = false) {
    try {
      const result = await getClassesReport(details);
      const formated = formatGroupBy(result);
      setReports(formated)
    } catch (error) {
      console.error('Erro: ', error)
    }
  }

  const pageStyle = `
  @media print{
    html, body{
      border-collapse: collapse;
      height: initial !important;
      overflow: initial !important;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
    table, th, td {
      border-collapse: collapse;
      white-space: normal;
    }
    .page-break {
      margin-top: 20px !important;
      display: block;
      page-break-before: auto;
    }

    div:nth-child(2) {
      height: auto;
    }
  }
  @page{
    margin: 20mm;
    size: auto;
  }
  `

  function checkIsOpen(item: any) {
    const _find = openList.find((op: any) => {
      if (op === item) {
        return true;
      }
      return false;
    });

    if (_find === null) {
      return true
    }

    return _find;
  }

  function handleOpen(item: any) {
    const _nome = item;
    const indexOf = openList.findIndex((it: any) => it === item);

    if (indexOf > -1) {
      const newList = [...openList];
      newList.splice(indexOf, 1);
      setOpenList(newList);
    } else {
      const newList = [...openList, _nome];
      setOpenList(newList);
    }
  }
  
  function _renderClassTr(item: any, identifier: number = 0, margin: number = 0): any {
    if (Array.isArray(item)) {
      return renderItemTable(item);
    } else {
      const _trs = item ? Object.keys(item) : [];

      return _trs.map((tr, index) => {
        const isOpen = nivelArvore && nivelArvore <= margin ? true : checkIsOpen(`${tr}${identifier}`) ;
        if (tr === 'null') return (<></>);
        return <>
          <tr className='button'>
            <td>
              <div onClick={() => handleOpen(`${tr}${identifier}`)} className='titleContainer'>
                <div className='plusBox' style={{ marginLeft: (margin) * 10 }}>
                  {isOpen ? <FaMinusSquare color='white' size={14} /> : <FaPlusSquare color='white' size={14} />}
                </div>
                <h4>{tr === 'null' ? ` ` : tr}</h4>
              </div>
            </td>
            {fields.map((_item, index) => index !== 0 && (
              <td key={index}></td>
            ))}
          </tr>
          {isOpen ? _renderClassTr(item[tr], index, 1 + margin) : null}
        </>
      })
    }
  }

  function renderItemTable (item: any) {
    // verifica se o item possui mais de um array dentro e transforma em um unico array.
    const _listReport = hasGroup ? Array.isArray(item) && item.length > 1 ? item.map((_it:any) => { return {..._it[0]}}) : item[0] : item;
    return _listReport && _listReport.map((it:any, idx:number) => {

      return <tr 
      key={idx}
      className={marcaTexto ? 'yellow' : ''} >
        {fields.map(field => {
          const value = valueMask(field, it);

          return (
            <td className={value && String(value) && String(value)[0] === '-' ? 'red-color-cell' : ''}>{value ?? ''}</td>
          )
        }
        )}
      </tr>
    })
  }

  function valueMask(field: any, it: any) {
    if(field.field === "Documento") {
      if(it.TipoDoc === 'NF-e' && it.NumeroDoc) {
        const rawValue = typeof it.NumeroDoc === "string" ? onlyNumberStr(it.NumeroDoc) : '';
        if(rawValue) {
          const completedString = ("000000000"+rawValue).slice(-9);
          const maskValue = completedString.replace(/\D/g, "")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(-\d{2})\d+?$/, "$1");
          return `${it.TipoDoc} ${it.SerieDoc} ${maskValue}`;
        } else {
          return rawValue;
        }
      } else if(it.NumeroDoc) {
        const rawValue = typeof it.NumeroDoc === "string" ? onlyNumberStr(it.NumeroDoc) : '';
        return `${it.TipoDoc} ${it.SerieDoc} ${rawValue}`;
      } else {
        return '';
      }
    } else {
      return it[field.field];
    }
  }

  function renderTable(listReports: any) {
    if(reports) {
      return _renderClassTr(listReports);
    } 
    return null
  }

  function handleOpenResumo() {
    let dtEmissao = convertToDate(date);
    let emissao = dtEmissao ? format(dtEmissao, 'dd/MM/yy eeeeee HH:mm', {
      locale: ptBR,
    }) : date;
    const copyFilters = [
      {
        label: 'Data',
        value: emissao,
      },
      {
        label: 'Versão do Sistema',
        value: VERSION,
      },
      ...filterLabel,
    ];
    openModal({
      title: `Resumo Variáveis`,
      children: () => <ResumeFiltersReport title={title} filters={copyFilters} />
    })
  }

  return (
    <Main>
      <Row>
        <Button onClick={() => history.goBack()}>Voltar</Button>
        <RightButtons>
          <Button onClick={handleOpenResumo}>Resumo</Button>
          <ReactToPrint
            trigger={() => {
              return <Button type='button' className=''>Imprimir</Button>
            }}
            content={() => componentRef.current}
            documentTitle="new document"
            pageStyle={pageStyle}
          />
        </RightButtons>
      </Row>

      <Container ref={componentRef}>
        <DivRow>
          {license && (
            <Row>
              <p>{license.nomeFantasia}</p>
              <label>Versão do Sistema: {VERSION}</label>
            </Row>
          )}
          <Row>
            <p>{title}</p>
            <label>{formatDateHorsComDiaSemana(date)}</label>
          </Row>
          <Row>
            <p>Admin \ Relatórios \ Listagem de Classes</p>
          </Row>
          {gerarCabecalho && (
            <FiltersContainer>
              <p className='title'>Filtros: </p>
              <p>
                {filterLabel.map((filter: any, index: any) => {
                  let value = '';

                  if (Array.isArray(filter.value)) {
                    if (filter.value.length === 0) value = 'Nenhum';
                    value = filter.value.map((it: any) => `${it} `);
                  } else {
                    if (filter.value instanceof Date) {
                      value = formatDate(filter.value);
                    } else {
                      value = filter.value;
                    }
                  }
                  return (
                    <label className='label'>
                      {filter.label} - <span className='span'>{value}</span>
                    </label>
                  )
                })}
              </p>
            </FiltersContainer>
          )}
        </DivRow>

        <DivItems>
          <table>
            <tr style={{ textAlign: 'left' }}>
              {fields.map((field) => <th
              key={field.field}>
                {field.label}
              </th>
              )}
            </tr>
            {renderTable(reports)}
          </table>
        </DivItems>

        <LogoFooter>
          <img src={LogoDevari} alt="Logo Devari" />
        </LogoFooter>
      </Container>
    </Main>
  )
}

export default ClassesReport;
